export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: 'de2e572', dateTime: 1790025492677 };